export default [
    {
        name: 'Austria',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'AT',
        flagURL: 'at',
        messageRo: 'Bine ați venit în Austria',
        messageLocal: 'Willkommen in Österreich',
        countryPhonePrefix: '43',
    },
    {
        name: 'Italia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'IT',
        flagURL: 'it',
        messageRo: 'Bine ați venit în Italia',
        messageLocal: 'Benvenuti in Italia',
        countryPhonePrefix: '39',
    },
    {
        name: 'Bulgaria',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'BG',
        flagURL: 'bg',
        messageRo: 'Bine ați venit în Bulgaria',
        messageLocal: 'Добре дошли в България',
        countryPhonePrefix: '359',
    },
    {
        name: 'Franța',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'FR',
        flagURL: 'fr',
        messageRo: 'Bine ați venit în Franța',
        messageLocal: 'Bienvenue en France',
        countryPhonePrefix: '33',
    },
    {
        name: 'Argentina',
        prepaid: 3,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'AR',
        flagURL: 'ar',
        messageRo: 'Bine ați venit în Argentina',
        messageLocal: 'Bienvenido a Argentina',
        countryPhonePrefix: '54',
    },

    {
        name: 'Africa de Sud',
        prepaid: 3,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'ZA',
        flagURL: 'za',
        messageRo: 'Bine ați venit în Africa de Sud',
        messageLocal: 'Welcome to South Africa',
        countryPhonePrefix: '27',
    },
    {
        name: 'Albania',
        prepaid: 2,
        postpaid: 'Balcani non-SEE',
        countryGroup: 1,
        internet: 7,
        countryCodeISO: 'AL',
        flagURL: 'al',
        messageRo: 'Bine ați venit în Albania',
        messageLocal: 'Mirë se erdhët në Shqipëri',
        countryPhonePrefix: '355',
    },
    {
        name: 'Afghanistan',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'AF',
        flagURL: 'af',
        messageRo: 'Bine ați venit în Afghanistan',
        messageLocal: 'Welcome to Afghanistan',
        countryPhonePrefix: '93',
    },
    {
        name: 'Algeria',
        prepaid: 3,
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'DZ',
        countryGroup: 2,
        flagURL: 'dz',
        messageRo: 'Bine ați venit în Algeria',
        messageLocal: 'Welcome to Algeria',
        countryPhonePrefix: '213',
    },
    {
        name: 'Andora',
        prepaid: 2,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'AD',
        flagURL: 'ad',
        messageRo: 'Bine ați venit în Andora',
        messageLocal: 'Welcome to Andorra',
        countryPhonePrefix: '376',
    },
    {
        name: 'Angola',
        prepaid: 3,
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'AO',
        flagURL: 'ao',
        messageRo: 'Bine ați venit în Angola',
        messageLocal: 'Welcome to Angola',
        countryPhonePrefix: '244',
    },
    {
        name: 'Antigua și Barbuda',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'AI',
        flagURL: 'ai',
        messageRo: 'Bine ați venit în Antigua și Barbuda',
        messageLocal: 'Welcome to Anguilla',
        countryPhonePrefix: '+1-264',
    },
    {
        name: 'Antilele Olandeze',
        prepaid: 3,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'AN',
        flagURL: 'an',
        messageRo: 'Bine ați venit în Antilele Olandeze',
        messageLocal: 'Welcome to Netherlands Antilles',
        countryPhonePrefix: '',
    },
    {
        name: 'Arabia Saudită',
        prepaid: 5,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'SA',
        flagURL: 'sa',
        messageRo: 'Bine ați venit în Arabia Saudită',
        messageLocal: 'Welcome to Saudi Arabia',
        countryPhonePrefix: '966',
    },

    {
        name: 'Armenia',
        prepaid: 4,
        postpaid: 6,
        countryGroup: 2,
        internet: 6,
        countryCodeISO: 'AM',
        flagURL: 'am',
        messageRo: 'Bine ați venit în Armenia',
        messageLocal: 'Welcome to Armenia',
        countryPhonePrefix: '374',
    },
    {
        name: 'Aruba',
        prepaid: 3,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'AW',
        flagURL: 'aw',
        messageRo: 'Bine ați venit în Aruba',
        messageLocal: 'Welcome to Aruba',
        countryPhonePrefix: '297',
    },
    {
        name: 'Australia',
        prepaid: 3,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'AU',
        flagURL: 'au',
        messageRo: 'Bine ați venit în Australia',
        messageLocal: 'Welcome to Australia',
        countryPhonePrefix: '61',
    },

    {
        name: 'Azerbaijan',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'AZ',
        flagURL: 'az',
        messageRo: 'Bine ați venit în Azerbaijan',
        messageLocal: 'Welcome to Azerbaijan',
        countryPhonePrefix: '994',
    },
    {
        name: 'Bahamas',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'BS',
        flagURL: 'bs',
        messageRo: 'Bine ați venit în Bahamas',
        messageLocal: 'Welcome to Bahamas',
        countryPhonePrefix: '+1-242',
    },
    {
        name: 'Bahrain',
        prepaid: 3,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'BH',
        flagURL: 'bh',
        messageRo: 'Bine ați venit în Bahrain',
        messageLocal: 'Welcome to Bahrain',
        countryPhonePrefix: '973',
    },
    {
        name: 'Bangladesh',
        prepaid: 5,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'BD',
        flagURL: 'bd',
        messageRo: 'Bine ați venit în Bangladesh',
        messageLocal: 'Welcome to Bangladesh',
        countryPhonePrefix: '880',
    },
    {
        name: 'Barbados',
        prepaid: 5,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'BB',
        flagURL: 'bb',
        messageRo: 'Bine ați venit în Barbados',
        messageLocal: 'Welcome to Barbados',
        countryPhonePrefix: '+1-246',
    },
    {
        name: 'Belarus',
        prepaid: 3,
        postpaid: 6,
        countryGroup: 2,
        internet: 6,
        countryCodeISO: 'BY',
        flagURL: 'by',
        messageRo: 'Bine ați venit în Belarus',
        messageLocal: 'Welcome to Belarus',
        countryPhonePrefix: '375',
    },
    {
        name: 'Belgia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'BE',
        flagURL: 'be',
        messageRo: 'Bine ați venit în Belgia',
        messageLocal: 'Welcome to Belgium',
        countryPhonePrefix: '32',
    },
    {
        name: 'Belize',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'BZ',
        flagURL: 'bz',
        messageRo: 'Bine ați venit în Belize',
        messageLocal: 'Welcome to Belize',
        countryPhonePrefix: '501',
    },
    {
        name: 'Sao Tome si Principe',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'ST',
        flagURL: 'st',
        messageRo: 'Bine ați venit în Sao Tome si Principe',
        messageLocal: 'Welcome to Sao Tome and Principe',
        countryPhonePrefix: '239',
    },
    {
        name: 'Benin',
        prepaid: 5,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'BJ',
        flagURL: 'bj',
        messageRo: 'Bine ați venit în Benin',
        messageLocal: 'Welcome to Benin',
        countryPhonePrefix: '229',
    },
    {
        name: 'Bermuda',
        prepaid: 5,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'BM',
        flagURL: 'bm',
        messageRo: 'Bine ați venit în Bermuda',
        messageLocal: 'Welcome to Bermuda',
        countryPhonePrefix: '+1-441',
    },
    {
        name: 'Bhutan',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'BT',
        flagURL: 'bt',
        messageRo: 'Bine ați venit în Bhutan',
        messageLocal: 'Welcome to Bhutan',
        countryPhonePrefix: '975',
    },
    {
        name: 'Bolivia',
        prepaid: 3,
        postpaid: 6,
        internet: 6,
        countryGroup: 2,
        countryCodeISO: 'BO',
        flagURL: 'bo',
        messageRo: 'Bine ați venit în Bolivia',
        messageLocal: 'Welcome to Bolivia',
        countryPhonePrefix: '591',
    },
    {
        name: 'Bosnia-Herțegovina',
        prepaid: 2,
        postpaid: 'Balcani non-SEE',
        countryGroup: 1,
        internet: 4,
        countryCodeISO: 'BA',
        flagURL: 'ba',
        messageRo: 'Bine ați venit în Bosnia-Herțegovina',
        messageLocal: 'Welcome to Bosnia and Herzegovina',
        countryPhonePrefix: '387',
    },
    {
        name: 'Botswana',
        prepaid: 3,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'BW',
        flagURL: 'bw',
        messageRo: 'Bine ați venit în Botswana',
        messageLocal: 'Welcome to Botswana',
        countryPhonePrefix: '267',
    },
    {
        name: 'Brazilia',
        prepaid: 3,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'BR',
        flagURL: 'br',
        messageRo: 'Bine ați venit în Brazilia',
        messageLocal: 'Welcome to Brazil',
        countryPhonePrefix: '55',
    },
    {
        name: 'Brunei',
        prepaid: 5,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'BN',
        flagURL: 'bn',
        messageRo: 'Bine ați venit în Brunei',
        messageLocal: 'Welcome to Brunei Darussalam',
        countryPhonePrefix: '673',
    },

    {
        name: 'Burkina Faso',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'BF',
        flagURL: 'bf',
        messageRo: 'Bine ați venit în Burkina Faso',
        messageLocal: 'Welcome to Burkina Faso',
        countryPhonePrefix: '226',
    },
    {
        name: 'Burundi',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'BI',
        flagURL: 'bi',
        messageRo: 'Bine ați venit în Burundi',
        messageLocal: 'Welcome to Burundi',
        countryPhonePrefix: '257',
    },
    {
        name: 'Cambodia',
        prepaid: 4,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'KH',
        flagURL: 'kh',
        messageRo: 'Bine ați venit în Cambodia',
        messageLocal: 'Welcome to Cambodia',
        countryPhonePrefix: '855',
    },
    {
        name: 'Camerun',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'CM',
        flagURL: 'cm',
        messageRo: 'Bine ați venit în Camerun',
        messageLocal: 'Welcome to Cameroon',
        countryPhonePrefix: '237',
    },
    {
        name: 'Canada',
        prepaid: 2,
        postpaid: 4,
        countryGroup: 1,
        internet: 4,
        countryCodeISO: 'CA',
        flagURL: 'ca',
        messageRo: 'Bine ați venit în Canada',
        messageLocal: 'Welcome to Canada',
        countryPhonePrefix: '1',
    },
    {
        name: 'Cehia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'CZ',
        flagURL: 'cz',
        messageRo: 'Bine ați venit în Cehia',
        messageLocal: 'Vítejte v České Republice',
        countryPhonePrefix: '420',
    },
    {
        name: 'Chile',
        prepaid: 3,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'CL',
        flagURL: 'cl',
        messageRo: 'Bine ați venit în Chile',
        messageLocal: 'Welcome to Chile',
        countryPhonePrefix: '56',
    },
    {
        name: 'China',
        prepaid: 2,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'CN',
        flagURL: 'cn',
        messageRo: 'Bine ați venit în China',
        messageLocal: '欢迎来到中国',
        countryPhonePrefix: '86',
    },
    {
        name: 'Cipru',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'CY',
        flagURL: 'cy',
        messageRo: 'Bine ați venit în Cipru',
        messageLocal: 'Welcome to Cyprus',
        countryPhonePrefix: '357',
    },
    {
        name: 'Coasta de Fildeș',
        prepaid: 5,
        postpaid: 4,
        internet: 4,
        countryCodeISO: 2,
        countryCodeISO: 'CI',
        flagURL: 'ci',
        messageRo: 'Bine ați venit în Coasta de Fildeș',
        messageLocal: 'Welcome to Ivory Coast',
        countryPhonePrefix: '225',
    },
    {
        name: 'Columbia',
        prepaid: 5,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'CO',
        flagURL: 'co',
        messageRo: 'Bine ați venit în Columbia',
        messageLocal: 'Bienvenidos a Colombia',
        countryPhonePrefix: '57',
    },
    {
        name: 'Coreea de Sud',
        prepaid: 3,
        postpaid: 3,
        internet: 3,
        countryGroup: 2,
        countryCodeISO: 'KR',
        flagURL: 'kr',
        messageRo: 'Bine ați venit în Coreea de Sud',
        messageLocal: 'Welcome to Korea (South)',
        countryPhonePrefix: '82',
    },
    {
        name: 'Costa Rica',
        prepaid: 3,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'CR',
        flagURL: 'cr',
        messageRo: 'Bine ați venit în Costa Rica',
        messageLocal: 'Welcome to Costa Rica',
        countryPhonePrefix: '506',
    },
    {
        name: 'Croația',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'HR',
        flagURL: 'hr',
        messageRo: 'Bine ați venit în Croația',
        messageLocal: 'Dobro došli u Hrvatsku',
        countryPhonePrefix: '385',
    },
    {
        name: 'Cuba',
        prepaid: '-',
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'CU',
        flagURL: 'cu',
        messageRo: 'Bine ați venit în Cuba',
        messageLocal: 'Welcome to Cuba',
        countryPhonePrefix: '53',
    },
    {
        name: 'Danemarca',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'DK',
        flagURL: 'dk',
        messageRo: 'Bine ați venit în Danemarca',
        messageLocal: 'Velkommen til Danmark',
        countryPhonePrefix: '45',
    },
    {
        name: 'Djibouti',
        prepaid: '-',
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'DJ',
        flagURL: 'dj',
        messageRo: 'Bine ați venit în Djibouti',
        messageLocal: 'Welcome to Djibouti',
        countryPhonePrefix: '253',
    },
    {
        name: 'Dominica',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'DM',
        flagURL: 'dm',
        messageRo: 'Bine ați venit în Dominica',
        messageLocal: 'Welcome to Dominica',
        countryPhonePrefix: '+1-767',
    },
    {
        name: 'Ecuador',
        prepaid: '-',
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'EC',
        flagURL: 'ec',
        messageRo: 'Bine ați venit în Ecuador',
        messageLocal: 'Welcome to Ecuador',
        countryPhonePrefix: '593',
    },
    {
        name: 'Egipt',
        prepaid: 2,
        postpaid: 2,
        countryGroup: 1,
        internet: 2,
        countryCodeISO: 'EG',
        flagURL: 'eg',
        messageRo: 'Bine ați venit în Egipt',
        messageLocal: 'Welcome to Egypt',
        countryPhonePrefix: '20',
    },
    {
        name: 'El Salvador',
        prepaid: 4,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'SV',
        flagURL: 'sv',
        messageRo: 'Bine ați venit în El Salvador',
        messageLocal: 'Welcome to El Salvador',
        countryPhonePrefix: '503',
    },
    {
        name: 'Elveția',
        prepaid: 2,
        postpaid: 2,
        countryGroup: 1,
        internet: 2,
        countryCodeISO: 'CH',
        flagURL: 'ch',
        messageRo: 'Bine ați venit în Elveția',
        messageLocal: 'Welcome to Switzerland',
        countryPhonePrefix: '41',
    },
    {
        name: 'Emiratele Arabe Unite',
        prepaid: 2,
        postpaid: 4,
        countryGroup: 1,
        internet: 4,
        countryCodeISO: 'AE',
        flagURL: 'ae',
        messageRo: 'Bine ați venit în Emiratele Arabe Unite',
        messageLocal: 'Welcome to United Arab Emirates',
        countryPhonePrefix: '971',
    },
    {
        name: 'Estonia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'EE',
        flagURL: 'ee',
        messageRo: 'Bine ați venit în Estonia',
        messageLocal: 'Welcome to Estonia',
        countryPhonePrefix: '372',
    },
    {
        name: 'Ethiopia',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'ET',
        flagURL: 'et',
        messageRo: 'Bine ați venit în Ethiopia',
        messageLocal: 'Welcome to Ethiopia',
        countryPhonePrefix: '251',
    },
    {
        name: 'Fiji',
        prepaid: 4,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'FJ',
        flagURL: 'fj',
        messageRo: 'Bine ați venit în Fiji',
        messageLocal: 'Welcome to Fiji',
        countryPhonePrefix: '679',
    },
    {
        name: 'Filipine',
        prepaid: 5,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'PH',
        flagURL: 'ph',
        messageRo: 'Bine ați venit în Filipine',
        messageLocal: 'Welcome to Philippines',
        countryPhonePrefix: '63',
    },
    {
        name: 'Finlanda',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'FI',
        flagURL: 'fi',
        messageRo: 'Bine ați venit în Finlanda',
        messageLocal: 'Tervetuloa Suomeen',
        countryPhonePrefix: '358',
    },

    {
        name: 'Gabon',
        prepaid: 5,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'GA',
        flagURL: 'ga',
        messageRo: 'Bine ați venit în Gabon',
        messageLocal: 'Welcome to Gabon',
        countryPhonePrefix: '241',
    },
    {
        name: 'Gambia',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'GM',
        flagURL: 'gm',
        messageRo: 'Bine ați venit în Gambia',
        messageLocal: 'Welcome to Gambia',
        countryPhonePrefix: '220',
    },
    {
        name: 'Georgia',
        prepaid: 4,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'GE',
        flagURL: 'ge',
        messageRo: 'Bine ați venit în Georgia',
        messageLocal: 'Welcome to Georgia',
        countryPhonePrefix: '995',
    },
    {
        name: 'Germania',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'DE',
        flagURL: 'de',
        messageRo: 'Bine ați venit în Germania',
        messageLocal: 'Willkommen in Deutschland',
        countryPhonePrefix: '49',
    },
    {
        name: 'Ghana',
        prepaid: 3,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'GH',
        flagURL: 'gh',
        messageRo: 'Bine ați venit în Ghana',
        messageLocal: 'Welcome to Ghana',
        countryPhonePrefix: '233',
    },
    {
        name: 'Gibraltar',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryGroup: 1,
        countryCodeISO: 'GI',
        flagURL: 'gi',
        messageRo: 'Bine ați venit în Gibraltar',
        messageLocal: 'Welcome to Gibraltar',
        countryPhonePrefix: '350',
        outOfEu: 1,
    },
    {
        name: 'Grecia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'GR',
        flagURL: 'gr',
        messageRo: 'Bine ați venit în Grecia',
        messageLocal: 'Καλως ηρθες στην ΕΛΛΑΔΑ',
        countryPhonePrefix: '30',
    },
    {
        name: 'Groenlanda',
        prepaid: 3,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'GL',
        flagURL: 'gl',
        messageRo: 'Bine ați venit în Groenlanda',
        messageLocal: 'Welcome to Greenland',
        countryPhonePrefix: '299',
    },
    {
        name: 'Guadelupa',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'GP',
        flagURL: 'gp',
        messageRo: 'Bine ați venit în Guadelupa',
        messageLocal: 'Welcome to Guadeloupe',
        countryPhonePrefix: '590',
    },
    {
        name: 'Guam',
        prepaid: 5,
        postpaid: 4,
        internet: 1,
        countryGroup: 2,
        countryCodeISO: 'GU',
        flagURL: 'gu',
        messageRo: 'Bine ați venit în Guam',
        messageLocal: 'Welcome to GU',
        countryPhonePrefix: '1-671',
    },
    {
        name: 'Guatemala',
        prepaid: 3,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'GT',
        flagURL: 'gt',
        messageRo: 'Bine ați venit în Guatemala',
        messageLocal: 'Welcome to Guatemala',
        countryPhonePrefix: '502',
    },
    {
        name: 'Guernsey',
        prepaid: 5,
        postpaid: 4,
        countryGroup: 1,
        internet: 4,
        countryCodeISO: 'GG',
        flagURL: 'gg',
        messageRo: 'Bine ați venit în Guernsey',
        messageLocal: 'Welcome to Guernsey',
        countryPhonePrefix: '+44-1481',
    },
    {
        name: 'Guineea',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'GN',
        flagURL: 'gn',
        messageRo: 'Bine ați venit în Guineea',
        messageLocal: 'Welcome to Guinea',
        countryPhonePrefix: '224',
    },
    {
        name: 'Guinea-Bissau',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'GW',
        flagURL: 'gw',
        messageRo: 'Bine ați venit în Guinea-Bissau',
        messageLocal: 'Welcome to Guinea-Bissau',
        countryPhonePrefix: '245',
    },
    {
        name: 'Guineea Ecuatoriala, Grenada',
        prepaid: 5,
        postpaid: 6,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'GD',
        flagURL: 'gd',
        messageRo: 'Bine ați venit în Guineea Ecuatoriala, Grenada',
        messageLocal: 'Welcome to Grenada',
        countryPhonePrefix: '+1-473',
    },
    {
        name: 'Guyana',
        prepaid: 3,
        postpaid: 1,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'GY',
        flagURL: 'gy',
        messageRo: 'Bine ați venit în Guyana',
        messageLocal: 'Welcome to Guyana',
        countryPhonePrefix: '592',
    },
    {
        name: 'Haiti',
        prepaid: '-',
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'HT',
        flagURL: 'ht',
        messageRo: 'Bine ați venit în Haiti',
        messageLocal: 'Welcome to Haiti',
        countryPhonePrefix: '509',
    },
    {
        name: 'Honduras',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'HN',
        flagURL: 'hn',
        messageRo: 'Bine ați venit în Honduras',
        messageLocal: 'Welcome to Honduras',
        countryPhonePrefix: '504',
    },
    {
        name: 'India',
        prepaid: 2,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'IN',
        flagURL: 'in',
        messageRo: 'Bine ați venit în India',
        messageLocal: 'Welcome to India',
        countryPhonePrefix: '91',
    },
    {
        name: 'Indonezia',
        prepaid: 2,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'ID',
        flagURL: 'id',
        messageRo: 'Bine ați venit în Indonezia',
        messageLocal: 'Welcome to Indonesia',
        countryPhonePrefix: '62',
    },
    {
        name: 'Insula Capului Verde',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'CV',
        flagURL: 'cv',
        messageRo: 'Bine ați venit în Insula Capului Verde',
        messageLocal: 'Welcome to República de Cabo Verde',
        countryPhonePrefix: '238',
    },
    {
        name: 'Insulele Cayman',
        prepaid: 3,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'CY',
        flagURL: 'cy',
        messageRo: 'Bine ați venit în Insulele Cayman',
        messageLocal: 'Welcome to Cayman Islands',
        countryPhonePrefix: '357',
    },
    {
        name: 'Insulele Cook',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'CK',
        flagURL: 'ck',
        messageRo: 'Bine ați venit în Insulele Cook',
        messageLocal: 'Welcome to Cook Islands',
        countryPhonePrefix: '682',
    },
    {
        name: 'Insulele Falkland',
        prepaid: '-',
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'FK',
        flagURL: 'fk',
        messageRo: 'Bine ați venit în Insulele Falkland',
        messageLocal: 'Welcome to Falkland Islands',
        countryPhonePrefix: '500',
    },
    {
        name: 'Insulele Feroe',
        prepaid: 3,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'FO',
        flagURL: 'fo',
        messageRo: 'Bine ați venit în Insulele Feroe',
        messageLocal: 'Welcome to Faroe Islands',
        countryPhonePrefix: '298',
    },
    {
        name: 'Insulele Norfolk',
        prepaid: '-',
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'NF',
        flagURL: 'nf',
        messageRo: 'Bine ați venit în Insulele Norfolk',
        messageLocal: 'Welcome to Norfolk Island',
        countryPhonePrefix: '672',
    },
    {
        name: 'Insulele Reunion',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'RE',
        flagURL: 're',
        messageRo: 'Bine ați venit în Insulele Reunion',
        messageLocal: 'Welcome to Reunion',
        countryPhonePrefix: '262',
    },
    {
        name: 'Insulele Solomon',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'SB',
        flagURL: 'sb',
        messageRo: 'Bine ați venit în Insulele Solomon',
        messageLocal: 'Welcome to Solomon Islands',
        countryPhonePrefix: '677',
    },
    {
        name: 'Insulele Turks și Caicos',
        prepaid: 3,
        postpaid: 3,
        internet: 3,
        countryGroup: 2,
        countryCodeISO: 'TC',
        flagURL: 'tc',
        messageRo: 'Bine ați venit în Insulele Turks și Caicos',
        messageLocal: 'Welcome to Turks and Caicos Islands',
        countryPhonePrefix: '+1-649',
    },
    {
        name: 'Insulele Virgine Britanice',
        prepaid: 4,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'VB',
        flagURL: 'vb',
        messageRo: 'Bine ați venit în Insulele Virgine Britanice',
        messageLocal: 'Welcome to British Virgin Islands',
        countryPhonePrefix: '',
    },
    {
        name: 'Iordania',
        prepaid: 5,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'JO',
        flagURL: 'jo',
        messageRo: 'Bine ați venit în Iordania',
        messageLocal: 'Welcome to Jordan',
        countryPhonePrefix: '962',
    },
    {
        name: 'Iraq',
        prepaid: 3,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'IQ',
        flagURL: 'iq',
        messageRo: 'Bine ați venit în Iraq',
        messageLocal: 'Welcome to Iraq',
        countryPhonePrefix: '964',
    },
    {
        name: 'Iran',
        prepaid: 5,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'IR',
        flagURL: 'ir',
        messageRo: 'Bine ați venit în Iran',
        messageLocal: 'Welcome to Islamic Republic of Iran',
        countryPhonePrefix: '98',
    },
    {
        name: 'Irlanda',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'IE',
        flagURL: 'ie',
        messageRo: 'Bine ați venit în Irlanda',
        messageLocal: 'Welcome to Ireland',
        countryPhonePrefix: '353',
    },
    {
        name: 'Islanda',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'IS',
        flagURL: 'is',
        messageRo: 'Bine ați venit în Islanda',
        messageLocal: 'Velkomin á Íslandi',
        countryPhonePrefix: '354',
    },
    {
        name: 'Israel',
        prepaid: 2,
        postpaid: 4,
        countryGroup: 1,
        internet: 4,
        countryCodeISO: 'IL',
        flagURL: 'il',
        messageRo: 'Bine ați venit în Israel',
        messageLocal: 'ברוכים הבאים לישראל',
        countryPhonePrefix: '972',
    },

    {
        name: 'Jamaica',
        prepaid: 4,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'JM',
        flagURL: 'jm',
        messageRo: 'Bine ați venit în Jamaica',
        messageLocal: 'Welcome to Jamaica',
        countryPhonePrefix: '+1-876',
    },
    {
        name: 'Japonia',
        prepaid: 2,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'JP',
        flagURL: 'jp',
        messageRo: 'Bine ați venit în Japonia',
        messageLocal: '日本へようこそ',
        countryPhonePrefix: '81',
    },
    {
        name: 'Jersey',
        prepaid: 2,
        postpaid: 3,
        countryGroup: 1,
        internet: 3,
        countryCodeISO: 'JE',
        flagURL: 'je',
        messageRo: 'Bine ați venit în Jersey',
        messageLocal: 'Welcome to Jersey',
        countryPhonePrefix: '+44-1534',
    },
    {
        name: 'Kazahstan',
        prepaid: 5,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'KZ',
        flagURL: 'kz',
        messageRo: 'Bine ați venit în Kazahstan',
        messageLocal: 'Welcome to Kazakhstan',
        countryPhonePrefix: '7',
    },
    {
        name: 'Kenya',
        prepaid: 5,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'KE',
        flagURL: 'ke',
        messageRo: 'Bine ați venit în Kenya',
        messageLocal: 'Welcome to Kenia',
        countryPhonePrefix: '254',
    },
    {
        name: 'Kuwait',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'KV',
        flagURL: 'kv',
        messageRo: 'Bine ați venit în Kuwait',
        messageLocal: 'Welcome to Kuwait',
        countryPhonePrefix: '965',
    },
    {
        name: 'Kyrgyzstan',
        prepaid: 5,
        postpaid: 6,
        countryGroup: 2,
        internet: 6,
        countryCodeISO: 'KG',
        flagURL: 'kg',
        messageRo: 'Bine ați venit în Kyrgyzstan',
        messageLocal: 'Welcome to Kyrgystan',
        countryPhonePrefix: '996',
    },
    {
        name: "Lao People's Democratic Republic",
        prepaid: 3,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'LA',
        flagURL: 'la',
        messageRo: 'Bine ați venit în Laos',
        messageLocal: 'Welcome to Lao PDR',
        countryPhonePrefix: '856',
    },
    {
        name: 'Lesotho',
        prepaid: 5,
        postpaid: 5,
        // countryGroup: 1,
        internet: 5,
        countryCodeISO: 'LS',
        flagURL: 'ls',
        messageRo: 'Bine ați venit în Lesotho',
        messageLocal: 'Welcome to Lesotho',
        countryPhonePrefix: '266',
    },
    {
        name: 'Letonia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'LV',
        flagURL: 'lv',
        messageRo: 'Bine ați venit în Letonia',
        messageLocal: 'Welcome to Latvia',
        countryPhonePrefix: '371',
    },
    {
        name: 'Liban',
        prepaid: 3,
        postpaid: 6,
        internet: 6,
        countryGroup: 2,
        countryCodeISO: 'LB',
        flagURL: 'lb',
        messageRo: 'Bine ați venit în Liban',
        messageLocal: 'Welcome to Lebanon',
        countryPhonePrefix: '961',
    },
    {
        name: 'Liberia',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 1,
        countryCodeISO: 'LR',
        flagURL: 'lr',
        messageRo: 'Bine ați venit în Liberia',
        messageLocal: 'Welcome to Liberia',
        countryPhonePrefix: '231',
    },
    {
        name: 'Libia',
        prepaid: '-',
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'LY',
        flagURL: 'ly',
        messageRo: 'Bine ați venit în Libia',
        messageLocal: 'Welcome to Libya',
        countryPhonePrefix: '218',
    },
    {
        name: 'Liechtenstein',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'LI',
        flagURL: 'li',
        messageRo: 'Bine ați venit în Liechtenstein',
        messageLocal: 'Welcome to Liechtenstein',
        countryPhonePrefix: '423',
        partnerOperator: 'Telecom FL',
        partnerOperatorScreenName: 'Telecom',
        partnerBandwidth: 'GSM 900',
    },
    {
        name: 'Lituania',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'LT',
        flagURL: 'lt',
        messageRo: 'Bine ați venit în Lituania',
        messageLocal: 'Welcome to Lithuania',
        countryPhonePrefix: '370',
    },

    //   {
    //      name: "Libya",
    //      prepaid: 1,
    //      postpaid: 1,
    //      internet: 1,
    //      countryCodeISO: "LY",
    //      flagURL: "ly",
    //      messageRo: "Bine ați venit în Libya",
    //      messageLocal: "Welcome to Libya",
    //      countryPhonePrefix: "218"
    //   },
    {
        name: 'Macau',
        prepaid: 3,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'MO',
        flagURL: 'mo',
        messageRo: 'Bine ați venit în Macau',
        messageLocal: 'Welcome to Macao',
        countryPhonePrefix: '853',
    },
    {
        name: 'Madagascar',
        prepaid: 4,
        postpaid: 6,
        internet: 6,
        countryGroup: 2,
        countryCodeISO: 'MG',
        flagURL: 'mg',
        messageRo: 'Bine ați venit în Madagascar',
        messageLocal: 'Welcome to Madagascar',
        countryPhonePrefix: '261',
    },
    {
        name: 'Malaezia',
        prepaid: 5,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'MY',
        flagURL: 'my',
        messageRo: 'Bine ați venit în Malaezia',
        messageLocal: 'Welcome to Malaysia',
        countryPhonePrefix: '60',
    },
    {
        name: 'Malawi',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'MW',
        flagURL: 'mw',
        messageRo: 'Bine ați venit în Malawi',
        messageLocal: 'Welcome to Malawi',
        countryPhonePrefix: '265',
    },
    {
        name: 'Maldive',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'MV',
        flagURL: 'mv',
        messageRo: 'Bine ați venit în Maldive',
        messageLocal: 'Welcome to Maldives',
        countryPhonePrefix: '960',
    },
    {
        name: 'Mali',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'ML',
        flagURL: 'ml',
        messageRo: 'Bine ați venit în Mali',
        messageLocal: 'Welcome to Mali',
        countryPhonePrefix: '223',
    },
    {
        name: 'Malta',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'MT',
        flagURL: 'mt',
        messageRo: 'Bine ați venit în Malta',
        messageLocal: 'Welcome to Malta',
        countryPhonePrefix: '356',
    },
    {
        name: 'Marea Britanie',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryGroup: 1,
        countryCodeISO: 'GB',
        flagURL: 'gb',
        messageRo: 'Bine ați venit în Marea Britanie',
        messageLocal: 'Welcome to United Kingdom',
        countryPhonePrefix: '44',
        prePaidOffers: [
            {
                offerPrice: 4,
                offerValability: 28,
                offerBenefits: [
                    {
                        icon: 'v630077',
                        label: `2 GB internet roaming Marea Britanie`,
                    },
                    {
                        icon: 'v630075',
                        label: `20 minute efectuate sau primite`,
                    },
                ],
                offerConsumables: [
                    {
                        label: `Se poate activa alaturi de alte oferte`,
                    },
                ],
                offerButtonLink: `https://factura.vodafone.ro/reincarca-o-cartela`,
            },
            {
                offerPrice: 10,
                offerValability: 28,
                offerBenefits: [
                    {
                        icon: 'v630077',
                        label: `8 GB internet roaming Marea Britanie`,
                    },
                    {
                        icon: 'v630075',
                        label: `100 minute efectuate sau primite`,
                    },
                ],
                offerConsumables: [
                    {
                        label: `Se poate activa alaturi de alte oferte`,
                    },
                ],
                offerButtonLink: `https://factura.vodafone.ro/reincarca-o-cartela`,
            },
        ],
    },
    {
        name: 'Maroc',
        prepaid: 2,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'MA',
        flagURL: 'ma',
        messageRo: 'Bine ați venit în Maroc',
        messageLocal: 'Welcome to Morocco',
        countryPhonePrefix: '212',
    },
    {
        name: 'Mauritania',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'MR',
        flagURL: 'mr',
        messageRo: 'Bine ați venit în Mauritania',
        messageLocal: 'Welcome to Mauritania',
        countryPhonePrefix: '222',
    },
    {
        name: 'Mauritius',
        prepaid: 4,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'MU',
        flagURL: 'mu',
        messageRo: 'Bine ați venit în Mauritius',
        messageLocal: 'Welcome to Mauritius',
        countryPhonePrefix: '230',
    },
    {
        name: 'Mexic',
        prepaid: 2,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'MX',
        flagURL: 'mx',
        messageRo: 'Bine ați venit în Mexic',
        messageLocal: 'Bienvenido a Mexico',
        countryPhonePrefix: '52',
    },
    {
        name: 'Monaco',
        prepaid: 2,
        postpaid: 3,
        countryGroup: 1,
        internet: 3,
        countryCodeISO: 'MC',
        flagURL: 'mc',
        messageRo: 'Bine ați venit în Monaco',
        messageLocal: 'Bienvenue à Monaco',
        countryPhonePrefix: '377',
    },
    {
        name: 'Mongolia',
        prepaid: 4,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'MN',
        flagURL: 'mn',
        messageRo: 'Bine ați venit în Mongolia',
        messageLocal: 'Welcome to Mongolia',
        countryPhonePrefix: '976',
    },
    {
        name: 'Montserrat',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'MS',
        flagURL: 'ms',
        messageRo: 'Bine ați venit în Montserrat',
        messageLocal: 'Welcome to Monserrat',
        countryPhonePrefix: '+1-664',
    },
    {
        name: 'Mozambic',
        prepaid: 3,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'MZ',
        flagURL: 'mz',
        messageRo: 'Bine ați venit în Mozambic',
        messageLocal: 'Welcome to Mozambique',
        countryPhonePrefix: '258',
    },
    {
        name: 'Muntenegru',
        prepaid: 2,
        postpaid: 'Balcani non-SEE',
        internet: 7,
        countryGroup: 1,
        countryCodeISO: 'ME',
        flagURL: 'me',
        messageRo: 'Bine ați venit în Muntenegru',
        messageLocal: 'Welcome to Montenegro',
        countryPhonePrefix: '382',
    },
    {
        name: 'Myanmar',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'MM',
        flagURL: 'mm',
        messageRo: 'Bine ați venit în Myanmar',
        messageLocal: 'Welcome to Myanmar',
        countryPhonePrefix: '95',
    },
    {
        name: 'Namibia',
        prepaid: 3,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'NA',
        flagURL: 'na',
        messageRo: 'Bine ați venit în Namibia',
        messageLocal: 'Welcome to Namibia',
        countryPhonePrefix: '264',
    },
    {
        name: 'Nepal',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'NP',
        flagURL: 'np',
        messageRo: 'Bine ați venit în Nepal',
        messageLocal: 'Welcome to Nepal',
        countryPhonePrefix: '977',
    },
    {
        name: 'Nicaragua',
        prepaid: 3,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'NI',
        flagURL: 'ni',
        messageRo: 'Bine ați venit în Nicaragua',
        messageLocal: 'Welcome to Nicaragua',
        countryPhonePrefix: '505',
    },
    {
        name: 'Niger',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'NE',
        flagURL: 'ne',
        messageRo: 'Bine ați venit în Niger',
        messageLocal: 'Welcome to Niger',
        countryPhonePrefix: '227',
    },
    {
        name: 'Nigeria',
        prepaid: 4,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'NG',
        flagURL: 'ng',
        messageRo: 'Bine ați venit în Nigeria',
        messageLocal: 'Welcome to Nigeria',
        countryPhonePrefix: '234',
    },
    {
        name: 'Norvegia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'NO',
        flagURL: 'no',
        messageRo: 'Bine ați venit în Norvegia',
        messageLocal: 'Velkommen til Norge',
        countryPhonePrefix: '47',
    },
    {
        name: 'Noua Caledonie',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'NC',
        flagURL: 'nc',
        messageRo: 'Bine ați venit în Noua Caledonie',
        messageLocal: 'Welcome to New Caledonia',
        countryPhonePrefix: '687',
    },
    {
        name: 'Noua Zeelandă',
        prepaid: 5,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'NZ',
        flagURL: 'nz',
        messageRo: 'Bine ați venit în Noua Zeelandă',
        messageLocal: 'Welcome to New Zealand',
        countryPhonePrefix: '64',
    },
    {
        name: 'Olanda',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'NL',
        flagURL: 'nl',
        messageRo: 'Bine ați venit în Olanda',
        messageLocal: 'Welcome to Netherlands',
        countryPhonePrefix: '31',
    },
    {
        name: 'Oman',
        prepaid: 3,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'OM',
        flagURL: 'om',
        messageRo: 'Bine ați venit în Oman',
        messageLocal: 'Welcome to Oman',
        countryPhonePrefix: '968',
    },
    {
        name: 'Pakistan',
        prepaid: 3,
        postpaid: 4,
        countryGroup: 2,
        internet: 6,
        countryCodeISO: 'PK',
        flagURL: 'pk',
        messageRo: 'Bine ați venit în Pakistan',
        messageLocal: 'Welcome to Pakistan',
        countryPhonePrefix: '',
    },
    {
        name: 'Palestina',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'PS',
        flagURL: 'ps',
        messageRo: 'Bine ați venit în Palestina',
        messageLocal: 'Welcome to Palestinian Teritory',
        countryPhonePrefix: '970',
    },
    {
        name: 'Panama',
        prepaid: 5,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'PA',
        flagURL: 'pa',
        messageRo: 'Bine ați venit în Panama',
        messageLocal: 'Welcome to Panama',
        countryPhonePrefix: '507',
    },
    {
        name: 'Papua Noua Guinee',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'PG',
        flagURL: 'pg',
        messageRo: 'Bine ați venit în Papua Noua Guinee',
        messageLocal: 'Welcome to Papua New Guinea',
        countryPhonePrefix: '675',
    },
    {
        name: 'Paraguay',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'PY',
        flagURL: 'py',
        messageRo: 'Bine ați venit în Paraguay',
        messageLocal: 'Welcome to Paraguay',
        countryPhonePrefix: 'PY',
    },
    {
        name: 'Peru',
        prepaid: 5,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'PE',
        flagURL: 'pe',
        messageRo: 'Bine ați venit în Peru',
        messageLocal: 'Welcome to Peru',
        countryPhonePrefix: '51',
    },
    {
        name: 'Polonia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'PL',
        flagURL: 'pl',
        messageRo: 'Bine ați venit în Polonia',
        messageLocal: 'Witamy w Polsce',
        countryPhonePrefix: '48',
    },
    {
        name: 'Portugalia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'PT',
        flagURL: 'pt',
        messageRo: 'Bine ați venit în Portugalia',
        messageLocal: 'Bem vindo a Portugal',
        countryPhonePrefix: '351',
    },
    {
        name: 'Puerto Rico',
        prepaid: 4,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'PR',
        flagURL: 'pr',
        messageRo: 'Bine ați venit în Puerto Rico',
        messageLocal: 'Welcome to Puerto Rico',
        countryPhonePrefix: '+1-787 și 1-939',
    },
    {
        name: 'Qatar',
        prepaid: 2,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'QA',
        flagURL: 'qa',
        messageRo: 'Bine ați venit în Qatar',
        messageLocal: 'Welcome to Qatar',
        countryPhonePrefix: '974',
    },
    {
        name: 'Republica Central Africana',
        prepaid: 3,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'CF',
        flagURL: 'cf',
        messageRo: 'Bine ați venit în Republica Centrafricana',
        messageLocal: 'Welcome to Central African Republic',
        countryPhonePrefix: '236',
    },
    {
        name: 'Republica Ciad',
        prepaid: 3,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'TD',
        flagURL: 'td',
        messageRo: 'Bine ați venit în Republica Ciad',
        messageLocal: 'Welcome to Chad',
        countryPhonePrefix: '235',
    },
    {
        name: 'Congo',
        prepaid: 3,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'CG',
        flagURL: 'cg',
        messageRo: 'Bine ați venit în Congo',
        messageLocal: 'Welcome to Congo',
        countryPhonePrefix: '242',
    },
    {
        name: 'Republica Democratică Congo',
        prepaid: 3,
        postpaid: 4,
        internet: 4,
        countryCodeISO: 'CG',
        flagURL: 'cg',
        messageRo: 'Bine ați venit în Republica Democratică Congo',
        messageLocal: 'Welcome to Congo',
        countryPhonePrefix: '242',
    },
    {
        name: 'Republica Dominicană',
        prepaid: 4,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'DO',
        flagURL: 'do',
        messageRo: 'Bine ați venit în Republica Dominicană',
        messageLocal: 'Welcome to Dominican Republic',
        countryPhonePrefix: '+1-809 și 1-829',
    },
    {
        name: 'Republica Macedonia',
        prepaid: 2,
        postpaid: 'Balcani non-SEE',
        countryGroup: 1,
        internet: 7,
        countryCodeISO: 'MK',
        flagURL: 'mk',
        messageRo: 'Bine ați venit în Republica Macedonia',
        messageLocal: 'Welcome to Republic of Macedonia',
        countryPhonePrefix: '389',
    },
    {
        name: 'Republica Moldova',
        prepaid: 2,
        postpaid: 3,
        countryGroup: 1,
        internet: 3,
        countryCodeISO: 'MD',
        flagURL: 'md',
        messageRo: 'Bine ați venit în Republica Moldova',
        messageLocal: 'Welcome to Moldova',
        countryPhonePrefix: '373',
    },
    {
        name: 'Rusia',
        prepaid: 2,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'RU',
        flagURL: 'ru',
        messageRo: 'Bine ați venit în Rusia',
        messageLocal: 'Добро пожаловать в Российскую Федерацию',
        countryPhonePrefix: '7',
    },
    {
        name: 'Rwanda',
        prepaid: 5,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'RW',
        flagURL: 'rw',
        messageRo: 'Bine ați venit în Rwanda',
        messageLocal: 'Welcome to Rwanda',
        countryPhonePrefix: '250',
    },
    {
        name: 'Samoa',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'WS',
        flagURL: 'ws',
        messageRo: 'Bine ați venit în Samoa',
        messageLocal: 'Welcome to Samoa',
        countryPhonePrefix: '685',
    },
    {
        name: 'Samoa Americana',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'ASM',
        flagURL: 'asm',
        messageRo: 'Bine ați venit în Samoa Americana',
        messageLocal: 'Welcome to Samoa Americana',
        countryPhonePrefix: '1684',
    },
    {
        name: 'Insulele Virgine Americane',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'VIR',
        flagURL: 'vir',
        messageRo: 'Bine ați venit în Insulele Virgine Americane',
        messageLocal: 'Welcome to Insulele Virgine Americane',
        countryPhonePrefix: '1340',
    },
    {
        name: 'Insula Craciunului',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 3,
        countryCodeISO: 'CX',
        flagURL: 'cx',
        messageRo: 'Bine ați venit în Insula Craciunului',
        messageLocal: 'Welcome to Christmas Island',
        countryPhonePrefix: '61',
    },
    {
        name: 'San Marino',
        prepaid: '-',
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'SM',
        flagURL: 'sm',
        messageRo: 'Bine ați venit în San Marino',
        messageLocal: 'Welcome to San Marino',
        countryPhonePrefix: '378',
    },
    {
        name: 'Senegal',
        prepaid: 4,
        postpaid: 6,
        internet: 6,
        countryGroup: 2,
        countryCodeISO: 'SN',
        flagURL: 'sn',
        messageRo: 'Bine ați venit în Senegal',
        messageLocal: 'Welcome to Senegal',
        countryPhonePrefix: '221',
    },
    {
        name: 'Serbia',
        prepaid: 2,
        postpaid: 'Balcani non-SEE',
        countryGroup: 1,
        internet: 7,
        countryCodeISO: 'RS',
        flagURL: 'rs',
        messageRo: 'Bine ați venit în Serbia',
        messageLocal: 'Добродошли у Србију',
        countryPhonePrefix: '381',
    },
    {
        name: 'Seychelles',
        prepaid: 4,
        postpaid: 6,
        countryGroup: 2,
        internet: 6,
        countryCodeISO: 'SC',
        flagURL: 'sc',
        messageRo: 'Bine ați venit în Seychelles',
        messageLocal: 'Welcome to Seychelles',
        countryPhonePrefix: '248',
    },
    {
        name: 'Sfantul Cristofor si Nevis',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'KN',
        flagURL: 'kn',
        messageRo: 'Bine ați venit în Sfantul Cristofor si Nevis',
        messageLocal: 'Welcome to Saint Kitts and Nevis',
        countryPhonePrefix: '+1-869',
    },
    {
        name: 'Sfantul Vicentiu si Grenadinele',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'VC',
        flagURL: 'vc',
        messageRo: 'Bine ați venit în Sfantul Vicentiu si Grenadinele',
        messageLocal: 'Welcome to Saint Vincent and the Grenadines',
        countryPhonePrefix: '+1-784',
    },
    {
        name: 'Sierra Leone',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'SL',
        flagURL: 'sl',
        messageRo: 'Bine ați venit în Sierra Leone',
        messageLocal: 'Welcome to Sierra Leone',
        countryPhonePrefix: '232',
    },
    {
        name: 'Singapore',
        prepaid: 2,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'SG',
        flagURL: 'sg',
        messageRo: 'Bine ați venit în Singapore',
        messageLocal: 'Welcome to Singapore',
        countryPhonePrefix: '65',
    },
    {
        name: 'Siria',
        prepaid: 3,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'SY',
        flagURL: 'sy',
        messageRo: 'Bine ați venit în Siria',
        messageLocal: 'Welcome to Syrian Arab Republic',
        countryPhonePrefix: '963',
    },
    {
        name: 'Slovakia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'SK',
        flagURL: 'sk',
        messageRo: 'Bine ați venit în Slovakia',
        messageLocal: 'Vitajte na Slovensku',
        countryPhonePrefix: '421',
    },
    {
        name: 'Slovenia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'SI',
        flagURL: 'si',
        messageRo: 'Bine ați venit în Slovenia',
        messageLocal: 'Dobrodošli v Sloveniji',
        countryPhonePrefix: '386',
    },
    {
        name: 'Spania',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'ES',
        flagURL: 'es',
        messageRo: 'Bine ați venit în Spania',
        messageLocal: 'Bienvenido a España',
        countryPhonePrefix: '34',
    },
    {
        name: 'Sri Lanka',
        prepaid: 5,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'LK',
        flagURL: 'lk',
        messageRo: 'Bine ați venit în Sri Lanka',
        messageLocal: 'Welcome to Sri Lanka',
        countryPhonePrefix: '94',
    },
    {
        name: 'Sfânta Lucia',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'LC',
        flagURL: 'lc',
        messageRo: 'Bine ați venit în Sfânta Lucia',
        messageLocal: 'Welcome to Saint Lucia',
        countryPhonePrefix: '+1-758',
    },
    {
        name: 'Somalia',
        prepaid: '-',
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'SO',
        flagURL: 'so',
        messageRo: 'Bine ați venit în Somalia',
        messageLocal: 'Welcome to Somalia',
        countryPhonePrefix: '252',
    },
    {
        name: 'Statele Unite ale Americii',
        prepaid: 2,
        postpaid: 2,
        countryGroup: 1,
        internet: 2,
        countryCodeISO: 'US',
        flagURL: 'us',
        messageRo: 'Bine ați venit în Statele Unite ale Americii',
        messageLocal: 'Welcome to United States of America',
        countryPhonePrefix: '1',
    },
    {
        name: 'Sudanul de Sud',
        prepaid: 3,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'SS',
        flagURL: 'sd',
        messageRo: 'Bine ați venit în Sudanul de Sud',
        messageLocal: 'Welcome to South Sudan',
        countryPhonePrefix: '249',
    },
    {
        name: 'Sudan',
        prepaid: 3,
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'SD',
        flagURL: 'sd',
        messageRo: 'Bine ați venit în Sudanul de Sud',
        messageLocal: 'Welcome to South Sudan',
        countryPhonePrefix: '249',
    },
    {
        name: 'Suedia',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'SE',
        flagURL: 'se',
        messageRo: 'Bine ați venit în Suedia',
        messageLocal: 'Välkommen till Sverige',
        countryPhonePrefix: '46',
    },
    {
        name: 'Surinam',
        prepaid: 3,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'SR',
        flagURL: 'sr',
        messageRo: 'Bine ați venit în Surinam',
        messageLocal: 'Welcome to Surinam',
        countryPhonePrefix: '597',
    },
    {
        name: 'Tajikistan',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'TJ',
        flagURL: 'tj',
        messageRo: 'Bine ați venit în Tajikistan',
        messageLocal: 'Welcome to Tajikistan',
        countryPhonePrefix: '992',
    },
    {
        name: 'Thailanda',
        prepaid: 2,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'TH',
        flagURL: 'th',
        messageRo: 'Bine ați venit în Thailanda',
        messageLocal: 'Welcome to Thailand',
        countryPhonePrefix: '66',
    },
    {
        name: 'Taiwan',
        prepaid: 3,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'TW',
        flagURL: 'tw',
        messageRo: 'Bine ați venit în Taiwan',
        messageLocal: 'Welcome to Taiwan',
        countryPhonePrefix: '886',
    },
    {
        name: 'Tanzania',
        prepaid: 5,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'TZ',
        flagURL: 'tz',
        messageRo: 'Bine ați venit în Tanzania',
        messageLocal: 'Welcome to United Republic of Tanzania',
        countryPhonePrefix: '255',
    },
    {
        name: 'Timor-Leste',
        prepaid: '-',
        postpaid: 6,
        internet: 6,
        countryGroup: 2,
        countryCodeISO: 'TL',
        flagURL: 'tl',
        messageRo: 'Bine ați venit în Timor-Leste',
        messageLocal: 'Welcome to Timor-Leste',
        countryPhonePrefix: '670',
    },
    {
        name: 'Togo',
        prepaid: 3,
        postpaid: 4,
        internet: 4,
        countryGroup: 2,
        countryCodeISO: 'TG',
        flagURL: 'tg',
        messageRo: 'Bine ați venit în Togo',
        messageLocal: 'Welcome to Togo',
        countryPhonePrefix: '228',
    },
    {
        name: 'Tonga',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'TO',
        flagURL: 'to',
        messageRo: 'Bine ați venit în Tonga',
        messageLocal: 'Welcome to Tonga',
        countryPhonePrefix: '676',
    },
    {
        name: 'Trinidad și Tobago',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryGroup: 2,
        countryCodeISO: 'TT',
        flagURL: 'tt',
        messageRo: 'Bine ați venit în Trinidad și Tobago',
        messageLocal: 'Welcome to Trinidad and Tobago',
        countryPhonePrefix: '+1-868',
    },
    {
        name: 'Tunisia',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryGroup: 2,
        countryCodeISO: 'TN',
        flagURL: 'tn',
        messageRo: 'Bine ați venit în Tunisia',
        messageLocal: 'Welcome to Tunisia',
        countryPhonePrefix: '216',
    },
    {
        name: 'Turcia',
        prepaid: 2,
        postpaid: 2,
        countryGroup: 1,
        internet: 2,
        countryCodeISO: 'TR',
        flagURL: 'tr',
        messageRo: 'Bine ați venit în Turcia',
        messageLocal: "Türkiye'ye hoşgeldiniz",
        countryPhonePrefix: '90',
    },
    {
        name: 'Turkmenistan',
        prepaid: 5,
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'TM',
        flagURL: 'tm',
        messageRo: 'Bine ați venit în Turkmenistan',
        messageLocal: 'Welcome to Turkmenistan',
        countryPhonePrefix: '993',
        partnerOperator: 'Altyn Asyr',
        partnerOperatorScreenName: 'Altyn Asyr',
        partnerBandwidth: 'GSM 900/1800',
    },
    {
        name: 'Ucraina',
        prepaid: 2,
        postpaid: 4,
        countryGroup: 1,
        internet: 4,
        countryCodeISO: 'UA',
        flagURL: 'ua',
        messageRo: 'Bine ați venit în Ucraina',
        messageLocal: 'Ласкаво просимо до України',
        countryPhonePrefix: '380',
    },
    {
        name: 'Uganda',
        prepaid: 3,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'UG',
        flagURL: 'ug',
        messageRo: 'Bine ați venit în Uganda',
        messageLocal: 'Welcome to Uganda',
        countryPhonePrefix: '256',
    },
    {
        name: 'Ungaria',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'HU',
        flagURL: 'hu',
        messageRo: 'Bine ați venit în Ungaria',
        messageLocal: 'Isten hozott Magyarországon',
        countryPhonePrefix: '36',
    },
    {
        name: 'Uruguay',
        prepaid: 3,
        postpaid: 3,
        countryGroup: 2,
        internet: 3,
        countryCodeISO: 'UY',
        flagURL: 'uy',
        messageRo: 'Bine ați venit în Uruguay',
        messageLocal: 'Bienvenido a Uruguay',
        countryPhonePrefix: '598',
    },
    {
        name: 'Uzbekistan',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'UZ',
        flagURL: 'uz',
        messageRo: 'Bine ați venit în Uzbekistan',
        messageLocal: 'Welcome to Uzbekistan',
        countryPhonePrefix: '998',
    },
    {
        name: 'Vanuatu',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'VU',
        flagURL: 'vu',
        messageRo: 'Bine ați venit în Vanuatu',
        messageLocal: 'Welcome to Vanuatu',
        countryPhonePrefix: '678',
    },
    {
        name: 'Venezuela',
        prepaid: '-',
        postpaid: 6,
        internet: 6,
        countryCodeISO: 'VE',
        flagURL: 've',
        messageRo: 'Bine ați venit în Venezuela',
        messageLocal: 'Welcome to Venezuela',
        countryPhonePrefix: '58',
    },
    {
        name: 'Vietnam',
        prepaid: 3,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'VN',
        flagURL: 'vn',
        messageRo: 'Bine ați venit în Vietnam',
        messageLocal: 'Welcome to Viet Nam',
        countryPhonePrefix: '84',
    },
    {
        name: 'Yemen',
        prepaid: 3,
        postpaid: 4,
        internet: 4,
        countryCodeISO: 'YE',
        flagURL: 'ye',
        messageRo: 'Bine ați venit în Yemen',
        messageLocal: 'Welcome to Yemen',
        countryPhonePrefix: '967',
    },
    {
        name: 'Zambia',
        prepaid: 4,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'ZM',
        flagURL: 'zm',
        messageRo: 'Bine ați venit în Zambia',
        messageLocal: 'Welcome to Zambia',
        countryPhonePrefix: '260',
    },
    {
        name: 'Zimbabwe',
        prepaid: 5,
        postpaid: 5,
        internet: 5,
        countryCodeISO: 'ZW',
        flagURL: 'zw',
        messageRo: 'Bine ați venit în Zimbabwe',
        messageLocal: 'Welcome to Zimbabwe',
        countryPhonePrefix: '263',
    },
    {
        name: 'Anguilla',
        prepaid: 3,
        postpaid: 5,
        internet: 1,
        countryGroup: 2,
        countryCodeISO: 'AI',
        flagURL: 'ai',
        messageRo: 'Bine ați venit în Anguilla',
        messageLocal: 'Welcome to Anguilla',
        countryPhonePrefix: '+1-264',
    },
    {
        name: 'Luxemburg',
        prepaid: 1,
        postpaid: 1,
        internet: 1,
        countryCodeISO: 'LU',
        flagURL: 'lu',
        messageRo: 'Bine ați venit în Luxemburg',
        messageLocal: 'Welcome to Luxembourg',
        countryPhonePrefix: '352',
    },

    {
        name: 'Polinezia',
        prepaid: 5,
        postpaid: 5,
        countryGroup: 2,
        internet: 5,
        countryCodeISO: 'PF',
        flagURL: 'pf',
        messageRo: 'Bine ați venit în Polynesia',
        messageLocal: 'Welcome to Polynesia',
        countryPhonePrefix: '689',
    },
    {
        name: 'Curacao',
        prepaid: 3,
        postpaid: 4,
        countryGroup: 2,
        internet: 4,
        countryCodeISO: 'CW',
        flagURL: 'cw',
        messageRo: 'Bine ați venit în Curacao',
        messageLocal: 'Welcome to Curacao',
        countryPhonePrefix: '599',
    },
    {
        name: 'Hong Kong',
        prepaid: 5,
        postpaid: 2,
        countryGroup: 2,
        internet: 2,
        countryCodeISO: 'HK',
        flagURL: 'hkt',
        messageRo: 'Bine ați venit în Hong Kong',
        messageLocal: 'Welcome to Hong Kong',
        countryPhonePrefix: '852',
    },
    {
        name: 'Insula Man',
        prepaid: 2,
        postpaid: 3,
        countryGroup: 1,
        internet: 3,
        countryCodeISO: 'IM',
        flagURL: 'im',
        messageRo: 'Bine ați venit în Insula Man',
        messageLocal: 'Welcome to Isle of Man',
        countryPhonePrefix: '+44-1624',
    },
    {
        name: 'Kosovo',
        prepaid: 2,
        postpaid: 'Balcani non-SEE',
        internet: 7,
        countryGroup: 1,
        countryCodeISO: 'XK',
        flagURL: 'xk',
        messageRo: 'Bine ați venit în Kosovo',
        messageLocal: 'Welcome to Kosovo',
        countryPhonePrefix: '',
    },
    //   zona "-" - no roaming - TBD
    {
        name: 'Kiribati',
        prepaid: '-',
        postpaid: 6,
        internet: 5,
        countryGroup: 2,
        countryCodeISO: 'KIR',
        flagURL: 'ki',
        messageRo: 'Bine ați venit în Kiribati',
        messageLocal: 'Welcome to Kiribati',
        countryPhonePrefix: '+686',
    },
    {
        name: 'Satelit Aircraft coverage',
        prepaid: 'Sateliti acoperire maritimă, acoperire în avion, sateliți tereștri',
        postpaid: 'Sateliti acoperire maritimă, acoperire în avion, sateliți tereștri',
        internet: 'Sateliti acoperire maritimă, acoperire în avion, sateliți tereștri',
        countryCodeISO: 'SATEL',
        flagURL: 'sat',
        //   messageRo: "Bine ați venit în Kiribati",
        //   messageLocal: "Welcome to Kiribati",
        countryPhonePrefix: '-',
    },
    {
        name: 'Satelit Thuraya',
        prepaid: 'Sateliti acoperire maritimă, acoperire în avion, sateliți tereștri',
        postpaid: 'Sateliti acoperire maritimă, acoperire în avion, sateliți tereștri',
        internet: 'Sateliti acoperire maritimă, acoperire în avion, sateliți tereștri',
        countryCodeISO: 'SATEL',
        flagURL: 'sat',
        //   messageRo: "Bine ați venit în Kiribati",
        //   messageLocal: "Welcome to Kiribati",
        countryPhonePrefix: '-',
    },
];
// ].sort((a, b) => {
//     if (a.name === b.name) return 0;
//     else if (a.name < b.name) return -1;
//     else return 1;
// })
